export const Resources = [
  'gold',
  'favor',
  'military',
  'warTokens',
  'tributeTokens',
] as const;

export type Resource = (typeof Resources)[number];

export const NameToResourceCharacter: Record<Resource, string> = {
  gold: 'G',
  favor: 'V',
  military: 'M',
  warTokens: 'W',
  tributeTokens: 'T',
};

export const CharacterToResourceName: Record<string, Resource> = {
  G: 'gold',
  V: 'favor',
  M: 'military',
  W: 'warTokens',
};

export const ResourceToDisplayName: Record<Resource, string> = {
  gold: 'Gold',
  favor: 'Favor',
  military: 'Military',
  warTokens: 'Clash',
  tributeTokens: 'Tribute',
};

export function getResourceSymbolPlaceholder(resource: Resource): string {
  return `$${resource.toUpperCase()}`;
}

export enum Token {
  War = 'War',
  Tribute = 'Tribute',
}
export function isToken(char: string): char is Token {
  return Token.hasOwnProperty(char);
}
export const TokenToDisplayName: Record<Token, string> = {
  War: 'War',
  Tribute: 'Tribute',
};

export function isResource(s: string): s is Resource {
  return Resources.includes(s as Resource);
}
export function assertResource(s: string): Resource {
  if (isResource(s)) {
    return s;
  }
  throw new Error(`Invalid resource: ${s}`);
}
